const C = {
  name: "Experiments2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.293 11.7071L20.0001 10.4142L9.7524 20.6618L9.74959 20.6646C8.89853 21.5271 7.74165 22 6.54 22C4.02588 22 2 19.9605 2 17.46C2 16.2506 2.48835 15.0975 3.33289 14.2529L13.5859 3.99995L12.293 2.70706L13.7072 1.29285L22.7072 10.2928L21.293 11.7071ZM5.41424 15L4.74711 15.6671C4.27165 16.1426 4 16.7895 4 17.46C4 18.8596 5.13412 20 6.54 20C7.21702 20 7.85892 19.734 8.3276 19.2583L8.33287 19.2529L12.5858 15H5.41424ZM7.41424 13H14.5858L18.5858 9.00003L15 5.41424L7.41424 13Z" fill="currentColor"/>
<path d="M21 4.25C21.6904 4.25 22.25 3.69036 22.25 3C22.25 2.30964 21.6904 1.75 21 1.75C20.3096 1.75 19.75 2.30964 19.75 3C19.75 3.69036 20.3096 4.25 21 4.25Z" fill="currentColor"/>
<path d="M22.25 15C22.25 15.5523 21.6904 16 21 16C20.3096 16 19.75 15.5523 19.75 15C19.75 14.4477 20.3096 14 21 14C21.6904 14 22.25 14.4477 22.25 15Z" fill="currentColor"/>
<path d="M6 7.25C6.69036 7.25 7.25 6.69036 7.25 6C7.25 5.30964 6.69036 4.75 6 4.75C5.30964 4.75 4.75 5.30964 4.75 6C4.75 6.69036 5.30964 7.25 6 7.25Z" fill="currentColor"/>
<path d="M16.25 21C16.25 21.5523 15.6904 22 15 22C14.3096 22 13.75 21.5523 13.75 21C13.75 20.4477 14.3096 20 15 20C15.6904 20 16.25 20.4477 16.25 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Experiments2
};
